module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [(_vm.activeimg.length) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.closeimg
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-container2",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.activeimg), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "flex-box"
    }, [_c('img', {
      attrs: {
        "src": item
      },
      on: {
        "click": _vm.closeimg
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-62fb0a03"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/lookimg.vue
// module id = 225
// module chunks = 49